export const educationData = [
    {
        id: 1,
        institution: 'KL University',
        course: 'B.Tech. Honours CSE, 9.06 CGPA%',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'Career Point World School',
        course: '12th Boards CBSE, 82.2%',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Career Point World School',
        course: '10th Boards CBSE, 73.4%',
        startYear: '2017',
        endYear: '2018'
    },
]